export default function dictToOptions(dict) {
  return Object.keys(dict).map(key => ({ label: dict[key], value: key }));
}
